import RegisterPasien from "../../components/RegisterPasien/HomePagePasienOnlinePenampungTambah";

export default function Register() {
  return (
    <div style={{backgroundColor:"white"}}>
      <RegisterPasien/>
    </div>
  );
}
